const {
  ACCOUNT_LEDGER_ORIGINAL_SOURCE,
} = require("constants/accountLedgerConstants");

const getLedgerSourceInfo = (originalSource, originalSourceRef) => {
  switch (originalSource) {
    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.PREPAYMENT:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.prepaymentID,
        link: "prepayment",
      };
    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.ADJUSTMENT:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.adjustmentID,
        link: "adjustment",
      };
    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.DELIVERY_COLLECTION:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.deliveryCollectionId,
        link: "delivery-collection",
      };
    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.COD_TRANSFER:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.codTransferId,
        link: "cod-transfer",
      };
    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.COC_COLLECTION:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.cocCollectionId,
        link: "coc-collection",
      };

    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.WITHDRAWAL:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.withdrawalID,
        link: "withdrawal",
      };
    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.DEPOSIT:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.depositID,
        link: "deposit",
      };
    case ACCOUNT_LEDGER_ORIGINAL_SOURCE.TRANSFER:
      return {
        _id: originalSourceRef?._id,
        label: originalSourceRef?.transferID,
        link: "transfer",
      };

    default:
      return {
        _id: null,
        label: "N/A",
        link: "unknown",
      };
  }
};

export { getLedgerSourceInfo };
